import React from 'react';

const LiquidGreyIcon = ({ width = 56, height = 130, color =  "#D9E2E3"  }) => {
    return (
        <svg
            width={width} 
            height={height}
            viewBox="0 0 56 130"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M8.61417 32.9712H7.95703V53.3426H8.61417V32.9712Z" fill={color} />
            <path d="M12.5575 34.2856H11.9004V53.3428H12.5575V34.2856Z" fill={color} />
            <path d="M16.4989 34.2856H15.8418V53.3428H16.4989V34.2856Z" fill={color} />
            <path d="M20.4423 34.2856H19.7852V53.3428H20.4423V34.2856Z" fill={color} />
            <path d="M24.3857 34.9424H23.7285V53.3424H24.3857V34.9424Z" fill={color} />
            <path d="M28.329 34.9424H27.6719V53.3424H28.329V34.9424Z" fill={color} />
            <path d="M32.2704 34.9424H31.6133V53.3424H32.2704V34.9424Z" fill={color} />
            <path d="M36.2138 34.2856H35.5566V53.3428H36.2138V34.2856Z" fill={color} />
            <path d="M40.1571 34.2856H39.5V53.3428H40.1571V34.2856Z" fill={color} />
            <path d="M44.1005 34.2856H43.4434V53.3428H44.1005V34.2856Z" fill={color} />
            <path d="M48.0419 32.9712H47.3848V53.3426H48.0419V32.9712Z" fill={color} />
            <path d="M53.5 57.0532C53.5 55.6725 52.3807 54.5532 51 54.5532H5C3.61929 54.5532 2.5 55.6725 2.5 57.0532V124.372C2.5 125.753 3.61929 126.872 5 126.872H51C52.3807 126.872 53.5 125.753 53.5 124.372V57.0532Z" stroke={color} strokeWidth="5" strokeLinejoin="round" />
            <path d="M51 54.4278C52.3807 54.4278 53.5 53.3085 53.5 51.9278V26.6546C53.5 25.99 53.2354 25.3527 52.7646 24.8836L31.0328 3.22909C30.5642 2.76217 29.9297 2.5 29.2682 2.5H26.3283C25.6587 2.5 25.0171 2.76863 24.5472 3.2457L3.21887 24.9003C2.75821 25.368 2.5 25.9981 2.5 26.6546V51.9278C2.5 53.3085 3.61929 54.4278 5 54.4278H51Z" stroke={color} strokeWidth="5" strokeLinejoin="round" />
            <path d="M7.99805 30.2866C7.99805 30.2866 14.8001 31.6652 28.0006 31.6652C41.2011 31.6652 48.1183 30.2866 48.1183 30.2866" stroke={color} strokeWidth="5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>




    );
};

export default LiquidGreyIcon;